import { createSlice } from "@reduxjs/toolkit"

import {
  handleFinishProjectRequest,
  handleStartProjectRequest
} from "./requestActionHandlers"
import { RequestReducerState } from "./types"

const initialState: RequestReducerState = {
  requests: { PROJECTS: {} }
}

const requestSlice = createSlice({
  name: "requests",
  initialState,
  reducers: {
    startProjectRequest: handleStartProjectRequest,
    finishProjectRequest: handleFinishProjectRequest
  }
})

export const { startProjectRequest, finishProjectRequest } =
  requestSlice.actions

export const requestActions = requestSlice.actions

export default requestSlice.reducer
